import React from 'react';
import ContentLoader from 'react-content-loader';

const Loader = ({ pageRange }) => {
  const height = 48 * (pageRange + 1);
  const body = new Array(pageRange + 1).fill(null).map((i, ind) => {
    let yStrip = ind ? 48 * ind + 8 : 12;

    if (ind === 0) {
      yStrip = 13;
    } else if (ind === 1) {
      yStrip = 71;
    } else {
      yStrip = 48 * (ind - 1) + 71;
    }

    return (
      <React.Fragment key={ind}>
        {ind ? (
          <>
            <rect x="15" y={yStrip} rx="3" ry="3" width="14" height="14" />
            <rect x="37" y={yStrip + 1} rx="3" ry="3" width="50" height="12" />
            <rect x="134" y={yStrip + 1} rx="3" ry="3" width="42" height="12" />
            <rect x="256" y={yStrip + 1} rx="3" ry="3" width="40" height="12" />
            <rect x="396" y={yStrip + 1} rx="3" ry="3" width="80" height="12" />
            <rect x="522" y={yStrip} rx="3" ry="3" width="170" height="12" />
            <rect x="793" y={yStrip} rx="3" ry="3" width="18" height="18" />
          </>
        ) : (
          <>
            <rect x="15" y={yStrip + 7} rx="3" ry="3" width="14" height="14" />
            <rect x="37" y={yStrip + 9} rx="3" ry="3" width="50" height="12" />
            <rect x="134" y={yStrip} rx="3" ry="3" width="72" height="24" />
            <rect x="256" y={yStrip + 9} rx="3" ry="3" width="85" height="12" />
            <rect x="396" y={yStrip + 9} rx="3" ry="3" width="31" height="12" />
            <rect x="522" y={yStrip + 9} rx="3" ry="3" width="90" height="12" />
          </>
        )}
      </React.Fragment>
    );
  });

  return (
    <ContentLoader
      speed={2}
      width={834}
      height={height}
      viewBox={`0 0 834 ${height}`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb">
      <>{body}</>
    </ContentLoader>
  );
};

export default Loader;
